// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { error } from 'react-notification-system-redux'

// this checks to make sure that the parent form was initialized
// that it has a values object
// and that it has a pagination property
// NOTE - pagination should either be null or an object.

// if any of these are false, the parent form was not initialized properly.

// NOTE - pagination will still work even if it wasn't initialized properly.

export const verifyParentFormWasInitializedProperly = sourceForm => (dispatch, getState) => {
  const { form } = getState()

  if (!form[sourceForm] || !form[sourceForm].values || form[sourceForm].values.pagination === undefined) {
    dispatch(error({
      autoDismiss: 0,
      message: `${sourceForm} was not correctly initialized to support pagination.`,
      title: 'Error Initializing Lookup',
    }))
  }
}
